import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { MerkatusLogo } from 'src/components/atoms/MerkatusLogo';
import DesktopNav from '../../molecules/DesktopNav';
import DesktopLogin from '../../molecules/DesktopLogin';
import MobileDrawerMenu from '../../molecules/MobileDrawerMenu';
import { IconButton } from 'src/components/atoms/IconButton';
import { Dispatch, SetStateAction } from 'react';
import { Icon } from 'src/components/atoms/Icon';
import DesktopSignUp from '../../molecules/DesktopSignUp';
import { IS_DEV } from 'src/constants';

type MarketingPageHeaderProps = {
  onLoginClick?: Dispatch<SetStateAction<boolean>>;
  onSignUpClick?: Dispatch<SetStateAction<boolean>>;
  showLinks?: boolean;
};

const MarketingPageHeader: React.FC<MarketingPageHeaderProps> = ({
  onLoginClick = () => {},
  onSignUpClick = () => {},
  showLinks = true,
}: MarketingPageHeaderProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box
        as="header"
        bg="text.darkBlue.900"
        w="100%"
        h="64px"
        borderBottom="1px solid #2C3E50"
        px={showLinks ? { base: 4, md: 12 } : { base: 4, md: 24, lg: 32 }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        zIndex={10}>
        <Flex
          w="100%"
          maxW={showLinks ? 'container.xl' : '100%'}
          align="center"
          justify="space-between">
          <MerkatusLogo />
          {showLinks && (
            <>
              <DesktopNav />
              <Box display="flex" gap={6} flexShrink={0}>
                <DesktopLogin onLoginClick={onLoginClick} />
                {IS_DEV && <DesktopSignUp onSignUpClick={onSignUpClick} />}
              </Box>
              {/* Mobile Hamburger */}
              <IconButton
                aria-label="Open menu"
                bg="text.darkBlue.800"
                borderRadius="full"
                alignItems="center"
                justifyContent="center"
                icon={<Icon iconName="hamburger" fill={'#F8F8FA'} />}
                variant="ghost"
                color="white"
                display={{ base: 'flex', lg: 'none' }}
                onClick={onOpen}
              />
            </>
          )}
        </Flex>
      </Box>
      <MobileDrawerMenu
        onLoginClick={onLoginClick}
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  );
};

export default MarketingPageHeader;
